export default {
    // ASTANDES
    async loadUsuariosAstandes ({commit, getters}) {
        let {data} = await getters.getApi.get("user")
        //console.log(data)
        return data.data
    },

    async migraUsuario ({commit, getters}, user) {
        let {data} = await getters.getApi.post(`user/migracao`, user)
        return data
    },

    async updateSaldo ({getters}, user) {
        let {data} = await getters.getApi.post("user/adicionaCredito", user)
        return data
    },

    async loadGrupos ({getters}, user_id) {
        let {data} = await getters.getService.get(`loginServer/grupos/${user_id}`)
        return data
    },

    async updateCliente ({getters}, cliente) {
        let {data} = await getters.getApi.put("user/updateUser", cliente)
       // console.log(data)
        return data
    },

    async updateOperator ({getters}, _id, operator) {
        let {data} = await getters.getApi.put("user/updateOperator", _id, operator)
        return data
    },

    async updateSmsMinNotify ({getters}, _id, updateSmsMinNotify) {
        let {data} = await getters.getApi.put("user/updateSmsMinNotify", _id, updateSmsMinNotify)
        return data
    },

    async enviosMes({getters}) {
        let {data} = await getters.getApi.get("sumarios")
        //console.log(data)
        return data
    },

    async enviosOperadora({getters}) {
        let {data} = await getters.getApi.get("sumarios/envios_operadora")
        //console.log(data)
        return (data.status) ? data.data :  []
    },

    async sumarios({getters}, sumario) {
        //console.log(typeof sumario)
        let {data} = await getters.getApi.get(`sumarios/envios_empresa`, { params: sumario })
        return (data.status) ? data.data :  []
    },

    async updateProtaxi({getters}, dados)
    {
        let {data} = await getters.getApi.post("user/changeProtaxi", dados)
        return data
    },

    async updateUserGroup({getters}, grupo)
    {
        let {data} = await getters.getService.put("loginServer/grupos", grupo)
        return data
    },

    async loadBoletosByUserId ({commit, getters}, user_id) {
        try {
            let {data} = await getters.getApi.get(`paymentHistory/${user_id}`)
            return data
        } catch(err) {
            return {
                status          : false,
                data:            [],
                creditsManual   : []
            }
        }
    },

    async updateStatusBoleto ({commit, getters}, obj) {
        try {
            const { data } = await getters.getApi.put(`payment/status`, obj)
            return data
        } catch(err) {
            return { status: false, message: 'Não foi possível mudar o Status desse boleto' }
        }
    },
    async enviosEmpresaPeriodo({getters}, { user_id,dt_ini,dt_fim}){
        try {
            const { data } = await getters.getApi.get(`/sumarios/${user_id}/${dt_ini}/${dt_fim}` )
            //console.log(data)
            return data
        } catch (err) {
            console.log('Erro: ', err)
            return { status: false }
        }
    },
    async getRelatorioGeral ({getters}, date) {
        try {
            const { data, status } = await getters.getApi.get(`/sumarios/totais_envios/${date}`)
           // console.log(data)
            return data
        } catch (err) {
            console.log('Erro: ', err)
            return { status: false }
        }
    },

    //Service Login
    /*async loadUsuariosAstandesServiceLogin({commit, getters}) {
        let {data} = await getters.getService.get("loginServer/empresas/byapp/5c374a10bf48b3021dde7571")
        return data
    }*/
}



// WEBPACK FOOTER //
// ./src/store/modules/root/actions.js